module.exports = __webpack_public_path__ + "static/media/icon-user.ac20b5e8.svg";